import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";

function GLSettingsTabPopup(props) {
    const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const { typedAccountNumber, setTypedAccountNumber } = props;

  const [filteredRightsListPopup, setFilteredRightsPopup] = useState(null);
  const {
    data: datagetVoucherNumberListPopup,
    loading: loadinggetVoucherNumberListPopup,
    error: errorgetVoucherNumberListPopup,
    get: getVoucherNumberListPopup,
  } = useApi();

  const [searchTextPopup, setSearchTextPopup] = useState("");

  useEffect(() => {
    getVoucherNumberListPopup(
      `https://cubixweberp.com:213/api/crmaccountlist/${COMPANY_CODE}/accountlist/${DEPARTMENT}/all/-/-`,
    );
  }, []);

  useEffect(() => {
    if (searchTextPopup?.length > 0) {

      console.log("datagetVoucherNumberListPopup", datagetVoucherNumberListPopup)
      const filtered = datagetVoucherNumberListPopup?.filter(
        (user) =>
          user.DESCRIPTION?.toLowerCase().includes(
            searchTextPopup.toLowerCase(),
          ) ||
          user.SCRN_CODE?.toLowerCase().includes(
            searchTextPopup.toLowerCase(),
          ) ||
          user.DEPTNO?.toLowerCase().includes(searchTextPopup.toLowerCase()) ||
          user.ACCOUNT?.toLowerCase().includes(searchTextPopup.toLowerCase()),
      );
      setFilteredRightsPopup(filtered);
    } else {
      setFilteredRightsPopup(datagetVoucherNumberListPopup);
    }
  }, [searchTextPopup]);

  useEffect(() => {
    setFilteredRightsPopup(datagetVoucherNumberListPopup);
  }, [datagetVoucherNumberListPopup]);

  return (
    <div className="p-4" style={{ overflowY: "scroll", height: "80vh" }}>
      <div className="flex justify-between items-center">
        <input
          value={searchTextPopup}
          onChange={(e) => setSearchTextPopup(e.target.value)}
          placeholder="Search"
          className="border border-gray-300 rounded px-3 py-2"
        />
      </div>
      <div className="mt-4" style={{ overflowY: "scroll" }}>
        <table
          class="min-w-full divide-y divide-gray-200 border border-gray-300"
          style={{ "border-collapse": "collapse" }}
        >
          <thead>
            <tr
              class="bg-gray-100"
              style={{ position: "sticky", top: "0px", zIndex: 3 }}
            >
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                ACCOUNT
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                DESCRIPTION
              </th>

              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                ACTION
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            {filteredRightsListPopup?.map((item) => {
              return (
                <tr class="hover:bg-gray-50">
                  <td class="px-6 py-4 text-sm text-gray-500">
                    <p>{item?.ACCOUNT}</p>
                  </td>
                  <td class="p-2 text-sm text-gray-500">
                    <div className="w-60">{item?.DESCRIPTION}</div>
                  </td>

                  <td>
                    <div className="flex">
                      <button
                        onClick={() => setTypedAccountNumber(item.ACCOUNT)}
                        className="ms-2 bg-blue-100 text-blue-700 font-semibold rounded p-2 my-4"
                      >
                        Select
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default GLSettingsTabPopup;
